export class CalendarioPublicacoesOutputDto {
  public dataAtualizacao: Date;
  public datasPublicacoesComunicadosCalendario: Date[];
  public datasSemPublicacao: Date[];

  constructor() {
      this.dataAtualizacao = new Date();
      this.datasPublicacoesComunicadosCalendario = [];
      this.datasSemPublicacao = [];
  }
}
